export class CartLineNetworkError extends Error {}

export class CartLineOutOfStockError extends Error {}

export class CartLineValidationError extends Error {}

export const STOCK_WARNING_CODES: ReadonlySet<string> = new Set([
  "MERCHANDISE_OUT_OF_STOCK",
  "MERCHANDISE_NOT_ENOUGH_STOCK",
]);

export const getCartLineErrorMessage = (error: unknown): string => {
  if (error instanceof CartLineNetworkError) {
    return "We couldn't reach the server. Please check your connection and try again.";
  }

  if (error instanceof CartLineOutOfStockError) {
    return "This item is currently out of stock. You can continue without it for now.";
  }

  return "We couldn't complete that action. You can continue without this product, please contact support if this keeps happening.";
};
